// src/slices/companySetupSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  kycCompanyName: '',
  kycRegistrationNumber: '',
  kycAnnualTurnover: '',
  address: {
    street: '',
    city: '',
    country: '',
  },
  type: '',
  logo: null,
};

const companySetupSlice = createSlice({
  name: 'companySetup',
  initialState,
  reducers: {
    updateCompanyName: (state, action) => {
      state.kycCompanyName = action.payload;
    },
    updateCompanyAddress: (state, action) => {
      state.address = { ...state.address, ...action.payload };
    },
    updateCompanyType: (state, action) => {
      state.type = action.payload;
    },
    updateCompanyLogo: (state, action) => {
      state.logo = action.payload;
    },
    updateCompanyData: (state, action) => {
      const { kycCompanyName, kycRegistrationNumber, kycAnnualTurnover, address, type, logo } = action.payload;
      if (kycCompanyName !== undefined) state.kycCompanyName = kycCompanyName;
      if (kycRegistrationNumber !== undefined) state.kycRegistrationNumber = kycRegistrationNumber;
      if (kycAnnualTurnover !== undefined) state.kycAnnualTurnover = kycAnnualTurnover;
      if (address !== undefined) state.address = { ...state.address, ...address };
      if (type !== undefined) state.type = type;
      if (logo !== undefined) state.logo = logo;
    },
  },
});

export const {
  updateCompanyName,
  updateCompanyAddress,
  updateCompanyType,
  updateCompanyLogo,
  updateCompanyData,
} = companySetupSlice.actions;

export default companySetupSlice.reducer;